module.exports = __webpack_public_path__ + "static/media/V-ID-1.cd36edc9.mp4";